<template>
  <div>
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{WZXMName}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
                <el-option
                      v-for="item in DianList"
                      :key="item.ID"
                      :label="item.StoresName"
                      :value="item.ID">
                </el-option>
            </el-select>
    </div>
    <div style="padding-top:30px">
        <div class="flex-spc-x" style="width:100%;">
                <div class="padding-left:5px" style="font-size:15px"> 
                   <el-form :inline="true" :model="formInline" class="flex-cen-x"  style="display:flex;flex-wrap:wrap;">
                     <el-form-item label="预约时间：">
                        <el-date-picker
                          v-model="date"
                          type="date"
                          placeholder="请选择时间"
                          size="mini"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"
                          style="width:170px"
                          />
                     </el-form-item>
                     <el-form-item label="">
          <el-input size="mini" v-model="selectMemberName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item label="">
              <el-select  clearable size="mini" @change="changeSiteTypeID()" v-model="selectSiteTypeID">
                      <el-option
                            v-for="item in  typeList"
                            :key="item.ID"
                            :label="item.SiteTypeName"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
        <el-form-item label="">
              <el-select  clearable size="mini" v-model="selectSiteID">
                      <el-option
                            v-for="item in ListSite"
                            :key="item.ID"
                            :label="item.SiteName"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>

                       <el-form-item>
                          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                   </el-form>
                  </div>
                <div>
              </div>
               <div class="flex-r-x">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-plus"
           @click="handleSiteClass()"
          >{{WZXMName}}排班</el-button>

 

 
        
      </div>
      
        </div>

<div class="left"  >
 <div class="all" >

<table class="move-table" border="1" cellspacing="0"  >
      <thead>
      <tr>
        <th style="height: 49px;">时间 </th>
      </tr>
      </thead>
 
      <tbody>
      <tr v-for="i,index in info">
        <th  >{{times[index]}}</th>
      </tr>
      </tbody>
    </table>
</div>

</div>

 <div class="right"  style="position: relative;width:91%;height: 100%;">
    <div class="all" style="width: 100%;overflow-x: scroll;">
 
    <table class="move-table" border="1" cellspacing="0"  >
      <thead>
      <tr>
        <th style="cursor: pointer " v-for="(items,index) in tableData1" >
          <span @click="handleEdit(items)"> {{items.SiteName}}</span>
          <div>
          <el-button
          size="mini"
          type="primary"
          icon="el-icon-plus"
          v-if="items.isedit==0"
           @click="toAddnew(items)"
          ></el-button>
           <el-button
          size="mini"
          type="primary"
          icon="el-icon-plus"
          v-if="items.isedit==1"
           @click="toAddnew1(items)"
          ></el-button>
          <el-button
          size="mini"
          type="primary"
          icon="el-icon-edit"
          v-if="items.isedit==1"
           @click="toLook(items)"
          ></el-button>
     
          </div>
          
        </th>
      </tr>
      </thead>
 
      <tbody>
      <tr v-for="i,index in info">
        <td    v-for="j in i" v-if="j" :rowspan="j==1? 1:j['time']" :class=" {cell:j&&j!=1&&j.pass,cell2:j&&j!=1&&!j.pass}">
          
           <span style="cursor: pointer " @click="toSowPreInfo(j)"> {{j?j.subject:''}}</span>

        </td>
      </tr>
      </tbody>
    </table>

     </div>

    </div>

    </div>

    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->


    <el-drawer :wrapperClosable= false title="预约详情" :visible.sync="editFormVisible" :direction="direction" size="80%">
       <div class="flex-spc-x" style="width:98%" >
         <div class="flexc-cen-x" style="padding-left:20px">   
            <img :src="yyList.HeadUrl" alt="" style="width:80px;height:80px;border-radius:5px">
              <div style="margin-left:15px">
                            <div class="titleMain" style="font-size:18px">
                              {{yyList.SiteName}}
                            </div>
                            <div class="content" style="margin-top:5px;">
                              <div>时长：{{yyList.Timelength}}分钟/{{yyList.TimelengthAmount}}元</div>
                              <div v-if="yyList.isPay == 1">定金：¥{{yyList.PayAmount}}</div>
                            </div>
              </div>
         </div>
          <el-button size="mini" type="primary" icon="el-icon-plus"  v-if="q1 == true && yyList.isedit==0"  @click="toAdd()">添加预约</el-button>
           <el-button size="mini" type="primary" icon="el-icon-plus"  v-if="q1 == true && yyList.isedit==1"  @click="toAdd1()">添加预约</el-button>

       </div>
        <div class="w100" style="margin-top:30px">
          <el-table :data="yyList.listPreAboutCD" highlight-current-row size="mini"   style="width:98%;margin-left:1%;margin-top:10px">
            <el-table-column  prop="yyTime" label="预约时间">
            </el-table-column>
            <el-table-column  prop="sTime" label="预约时长" >
                <template slot-scope="scope">
                    <div>{{scope.row.sTime}} ~ {{scope.row.eTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="PayAmount" label="定金"  v-if="yyList.isPay == 1" align="center">
            </el-table-column>
            <el-table-column  prop="Name" label="顾客信息">
              <template slot-scope="scope">
                  <div class="flexc-cen-x">
                  <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                  <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div v-if="scope.row.Name !=''" style="margin-left:5px;font-size:13px">{{scope.row.Name}}</div>
                <div v-else style="margin-left:5px;font-size:13px">{{scope.row.wxName}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column  prop="Phone" label="联系电话"  align="center">
            </el-table-column>
            <el-table-column  prop="vipName" label="会员卡"  align="center">
            </el-table-column>
            <el-table-column prop="PreAboutCount" label="预约人数" align="center" >
            </el-table-column>
            <el-table-column  prop="state" label="状态" align="center" width="150">
                    <template slot-scope="scope">
                      <span class="Info" v-if="scope.row.state == 0">
                        学员取消
                      </span>
                      <span class="coBlue" v-if="scope.row.state == 1">
                        已预约
                      </span>
                      <span class="Success" v-if="scope.row.state == 2">
                        已{{typeName}}
                      </span>
                      <span class="Danger" v-if="scope.row.state == 3">
                      未到
                      </span>
                      <span class="Info" v-if="scope.row.state == 4">
                        机构取消
                      </span>
                      <span class="Warning" v-if="scope.row.state == 5">
                      请假
                      </span>
                    </template>
            </el-table-column>
            <el-table-column prop="Note" label="备注" align="center" >
            </el-table-column>
         
            <!-- <el-table-column  prop="terName" label="业务归属人"  align="center">
            </el-table-column> -->
            <el-table-column align="center" label="操作" width="300" >
              <template slot-scope="scope">
                <el-button size="mini" type="success" v-if="(scope.row.state == 2||scope.row.state == 3 || scope.row.state == 5 ) && q5 == true"   @click="chexiao(scope.row)" >撤销</el-button>
                <el-button size="mini" type="primary"  v-if="scope.row.state == 1 && q2 == true" @click="hexiao(scope.row)" >{{typeName}}</el-button>
                <el-button size="mini" type="warning" v-if="scope.row.state == 1 && q3 == true" @click.native.prevent="todel(scope.row)" >取消预约</el-button>
                <!-- <el-button size="mini" type="warning" v-if="scope.row.state != 1 && q3 == true" disabled @click.native.prevent="todel(scope.row)" >取消预约</el-button> -->
                <el-button size="mini" type="info" v-if="scope.row.state == 1 && q4 == true" @click.native.prevent="todel2(scope.row)" >未到</el-button>
                <!-- <el-button size="mini" type="info" v-if="scope.row.state != 1 && q4 == true" disabled @click.native.prevent="todel1(scope.row)" >未到</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          ·
        </div>
    </el-drawer>
    <!-- </el-dialog> -->

    <el-dialog title="添加预约" :visible.sync="yuyueShow"   width="600px" @click="yuyueShow = false">
      <div class="w100 hidden">
          <el-form label-width="100px" :model="editForm">
            <el-form-item label="预约时间:">
                <el-date-picker
                            v-model="SleletyyTime"
                            type="date"
                            placeholder="请选择时间"
                            size="mini"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            style="width:170px"
                            @change="handleSleletyyTime" 

                            >
                          </el-date-picker>
                  </el-form-item>
                 <el-form-item label="类型" prop="isMembers" >

                
                <el-radio-group v-model="isMembers">
                  <el-radio :label="1">选择{{WZHYName}}</el-radio>
                  <el-radio :label="0">非{{WZHYName}}</el-radio>
                </el-radio-group>
              </el-form-item>
                <el-form-item :label="'选择'+WZHYName +':'" prop="" v-if="isMembers == 1">
                  <span>{{vipName}}</span>
                  <el-button style="margin-left:10px" type="text"  @click="toVipShow">选择</el-button>
                </el-form-item>
              <el-form-item label="姓名:" prop="Name" v-if="isMembers == 0">
                <el-input size="small" v-model="Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
              </el-form-item>
              <el-form-item label="手机号:" prop="Phone" v-if="isMembers == 0">
                <el-input size="small" v-model="Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
              </el-form-item>
              <el-form-item label="选择子账号:" v-if="subList.length>0 && isMembers == 1 "  >
                  <el-select v-model="MembersSubID" placeholder="请选择" size="small" clearable>
                    <el-option
                      v-for="item in subList"
                      :key="item.ID"
                      :label="item.Name"
                      :value="item.ID">
                    </el-option>
                  </el-select>
              </el-form-item>
               <el-form-item label="选择会员卡:"   v-if="isMembers == 1">
          <el-select v-model="vipID" placeholder="请选择" size="small"  >
              <el-option
                v-for="item in MembersvipList"
                :key="item.vipID"
                :label="item.CardName"
                :value="item.vipID">
              </el-option>
          </el-select>
        </el-form-item>
              <el-form-item label="预约人数:">
                <el-input-number size="small" v-model="PreAboutCount"  :min="1" :step="1"  ></el-input-number>
              </el-form-item>
              <el-form-item label="开始时间:"  >
                  <el-select v-model="sTime" placeholder="请选择" size="small" clearable @change="selectEndTimes">
                    <el-option
                      v-for="item in StimeList"
                      :key="item.ID"
                      :label="item.startTime"
                      :value="item.startTime"
                       >
                    </el-option>
                  </el-select>
              </el-form-item>
             <el-form-item label="结束时间:"  >
                  <el-select v-model="eTime" placeholder="请选择" size="small" clearable>
                    <el-option
                      v-for="item in EtimeList"
                      :key="item.ID"
                      :label="item.startTime"
                      :value="item.startTime">
                    </el-option>
                  </el-select>
              </el-form-item>
             
                <el-form-item label="不限时长:" v-if="showList.isbxsc == 1">
                    <el-radio-group v-model="isbxsc">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
              </el-form-item>
                <!-- <el-form-item label="预约时长:" v-if="isbxsc == 0">
                  <el-input-number size="small" v-model="yysc"  :min="1" :step="1"  ></el-input-number> {{showList.Timelength}}分钟
              </el-form-item> -->
                <el-form-item label="定金:" prop="PayAmount" v-if="showList.isPay == 1" >
                  <el-input size="small" v-model="PayAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
                </el-form-item>
                <el-form-item label="备注:" prop="Note">
                          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" style="width:90%"></el-input>
                </el-form-item>
              <div v-if="showList.isPreAboutInfo == 1 " :key="timer" >
                <el-form-item  v-for="(item,index) in ListPreAboutForms" :label="item.Title" :key="index" >
                  <div class="flexc-cen-x"  v-if="item.fType == 2">
                      <el-date-picker
                        @input="forceUpdate"
                        v-model="ListPreAboutForms[index].date"
                        style="width:200px"
                        type="date"
                        size="small"
                        placeholder="选择日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                      </el-date-picker>
                        <el-select   v-model="ListPreAboutForms[index].time" size="small" style="width:90px;margin-left:5px" filterable  @input="forceUpdate">
                          <el-option  v-for="item in coursetime" 
                                  :value="item.value" 
                                  :label="item.label" 
                                  :key="item.value">
                                </el-option>
                            </el-select>   
                            <span style="margin-left:5px;margin-right:5px">:</span>
                        <el-select size="small" v-model="ListPreAboutForms[index].time1" style="width:90px;" filterable  @input="forceUpdate">
                                <el-option v-for="item in coursetminu" :value="item.value" :label="item.label" :key="item.value">
                                </el-option>
                            </el-select> 
                    <span v-if="item.isbt == 1" style="color:red;margin-left:5px">*</span>

                  </div>

                      <el-input style="width:200px"   v-if="item.fType == 1" v-model="ListPreAboutForms[index].info" :key="timer" size="small" placeholder="请输入内容"    @input="forceUpdate"></el-input>
                      <span v-if="item.isbt == 1 && item.fType == 1" style="color:red">*</span>
              </el-form-item>
              </div>

          </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="yuyueShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="subm()">确定</el-button>
      </div>
    </el-dialog>
    
      <el-dialog title="添加预约" :visible.sync="yuyueShowSJ"   width="600px" @click="yuyueShowSJ = false">
      <div class="w100 hidden">
          <el-form label-width="100px" :model="editForm">
              <el-form-item label="类型" prop="isMembers" >
                <el-radio-group v-model="isMembers">
                  <el-radio :label="1">选择{{WZHYName}}</el-radio>
                  <el-radio :label="0">非{{WZHYName}}</el-radio>
                </el-radio-group>
              </el-form-item>
                <el-form-item :label="'选择'+WZHYName +':'" prop="" v-if="isMembers == 1">
                  <span>{{vipName}}</span>
                  <el-button style="margin-left:10px" type="text"  @click="toVipShow">选择</el-button>
                </el-form-item>
              <el-form-item label="姓名:" prop="Name" v-if="isMembers == 0">
                <el-input size="small" v-model="Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
              </el-form-item>
              <el-form-item label="手机号:" prop="Phone" v-if="isMembers == 0">
                <el-input size="small" v-model="Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
              </el-form-item>
              <el-form-item label="选择子账号:" v-if="subList.length>0 && isMembers == 1 "  >
                  <el-select v-model="MembersSubID" placeholder="请选择" size="small" clearable>
                    <el-option
                      v-for="item in subList"
                      :key="item.ID"
                      :label="item.Name"
                      :value="item.ID">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="选择会员卡:" v-if="isMembers == 1" >
          <el-select v-model="vipID" placeholder="请选择" size="small"  >
              <el-option
                v-for="item in MembersvipList"
                :key="item.vipID"
                :label="item.CardName"
                :value="item.vipID">
              </el-option>
          </el-select>
        </el-form-item>
              <el-form-item label="预约人数:">
                <el-input-number size="small" v-model="PreAboutCount"  :min="1" :step="1"  ></el-input-number>
              </el-form-item>
               
             <el-form-item label="选择时间:" >
              <el-select v-model="RowClassTimeID" placeholder="请选择" size="small" style="width:160px">
                <el-option
                  v-for="item in ListSiteClassTime"
                  :key="item.ID"
                  :label="item.startTimeNew"
                  :value="item.ID">
                </el-option>
              </el-select>
           </el-form-item>
             
                <el-form-item label="不限时长:" v-if="showList.isbxsc == 1">
                    <el-radio-group v-model="isbxsc">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
              </el-form-item>
                <!-- <el-form-item label="预约时长:" v-if="isbxsc == 0">
                  <el-input-number size="small" v-model="yysc"  :min="1" :step="1"  ></el-input-number> {{showList.Timelength}}分钟
              </el-form-item> -->
                <el-form-item label="定金:" prop="PayAmount" v-if="showList.isPay == 1" >
                  <el-input size="small" v-model="PayAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
                </el-form-item>
                <el-form-item label="备注:" prop="Note">
                          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" style="width:90%"></el-input>
                </el-form-item>
              <div v-if="showList.isPreAboutInfo == 1 " :key="timer" >
                <el-form-item  v-for="(item,index) in ListPreAboutForms" :label="item.Title" :key="index" >
                  <div class="flexc-cen-x"  v-if="item.fType == 2">
                      <el-date-picker
                        @input="forceUpdate"
                        v-model="ListPreAboutForms[index].date"
                        style="width:200px"
                        type="date"
                        size="small"
                        placeholder="选择日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                      </el-date-picker>
                        <el-select   v-model="ListPreAboutForms[index].time" size="small" style="width:90px;margin-left:5px" filterable  @input="forceUpdate">
                          <el-option  v-for="item in coursetime" 
                                  :value="item.value" 
                                  :label="item.label" 
                                  :key="item.value">
                                </el-option>
                            </el-select>   
                            <span style="margin-left:5px;margin-right:5px">:</span>
                        <el-select size="small" v-model="ListPreAboutForms[index].time1" style="width:90px;" filterable  @input="forceUpdate">
                                <el-option v-for="item in coursetminu" :value="item.value" :label="item.label" :key="item.value">
                                </el-option>
                            </el-select> 
                    <span v-if="item.isbt == 1" style="color:red;margin-left:5px">*</span>

                  </div>

                      <el-input style="width:200px"   v-if="item.fType == 1" v-model="ListPreAboutForms[index].info" :key="timer" size="small" placeholder="请输入内容"    @input="forceUpdate"></el-input>
                      <span v-if="item.isbt == 1 && item.fType == 1" style="color:red">*</span>
              </el-form-item>
              </div>

          </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="yuyueShowSJ = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="subm1()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'选择'+WZHYName" :visible.sync="vipShow" >
      <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:-20px">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="selectName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchhui">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table  :data="vipList" highlight-current-row  max-height="400" style="width: 100%;">

          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0"  prop="czAmount" label="储蓄金额(元)"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0" prop="syNumber" label="次卡次数"  align="center">
          </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
    </el-dialog>
    <el-dialog :title="typeName" :visible.sync="hexiaoShow" width="40%">

    <el-form label-width="120px" >
        <el-form-item label="定金" prop="number" v-if="mainList.isZF != 0 && mainList.isPay==1" >
          {{mainList.PayAmount}}元
        </el-form-item>
        <el-form-item :label="typeName+'码'" prop="number" v-if="mainList.isZF == 1 ">
          <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="typeName+'方式:'" prop="isCode">
          <el-radio-group v-model="isChooseVip">
            <el-radio :label="1">会员卡</el-radio>
            <el-radio :label="2">现场支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if=" isChooseVip == 2">
          <el-input size="small" placeholder="请输入金额" v-model="PayAmountqt" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
        </el-form-item>
        <el-form-item label="选择会员卡:" v-if="isChooseVip == 1 && vipName ==''" >
              <el-select v-model="vipNames" placeholder="请选择" size="small" @change="tochoosevip">
                <el-option
                  v-for="item in MembersvipList"
                  :key="item.index"
                  :label="item.CardName"
                  :value="item">
                </el-option>
              </el-select>
        </el-form-item>
         <el-form-item label="选择会员卡:" v-if="isChooseVip == 1 && vipName !=''" >
              {{vipName}}
        </el-form-item>
        <el-form-item :label="typeName+'方式:'" prop="isCode" v-if=" isCard == 0 && isChooseVip == 1">
          <el-radio-group v-model="vipID">
            <el-radio :label="-1">储蓄卡</el-radio>
            <el-radio :label="-2">储次卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if=" vipID==-1 && isCard == 0 && isChooseVip == 1">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if=" vipID == -2 && isCard == 0 && isChooseVip == 1" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
          <el-form-item label="金额" prop="number" v-if="(cardType == 4 || cardType == 5)   && isCard == 1 && isChooseVip == 1">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
        <el-form-item label="次数" prop="number" v-if="(cardType == 1 || cardType == 2)  && isCard == 1 && isChooseVip == 1" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
          </el-form-item>
          <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
        </el-form-item>

        <el-form-item label="选择业务归属人" prop="number" >
            <span>{{terName}}</span>
            <el-button type="text" style="margin-left:20px" @click="handlePassword1">选择</el-button>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
    </div>
    </el-dialog>
            <!--查看大封面-->
      <el-dialog title="未到" :visible.sync="weiShow" width="500px" @click="weiShow = false">
            <el-form label-width="120px" >
              <el-form-item label="扣除定金:" prop="Note">
                <div>{{mainList.PayAmount}}元</div>
              </el-form-item>
              <el-form-item label="备注:" prop="Note">
                <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
              </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="weiShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="weidao()">确定</el-button>
      </div>
      </el-dialog>
      <el-dialog title="选择业务归属人" :visible.sync="personShow" width="500px" @click="personShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
     <el-dialog title="已经被预约时间" :visible.sync="timeShow" width="500px" @click="timeShow = false">
       <div class="flex-xy" v-for="(items,index)  in timeList" :key="index">
          <div style="margin-top:20px;font-size:20px"><span>{{index+1}}.</span><span style="margin-left:15px">{{items.yyTime}}</span><span style="margin-left:10px">{{items.sTime}}~{{items.eTime}}</span> </div>
       </div>
     </el-dialog>
    <el-dialog title="撤销" :visible.sync="cheShow" width="40%">
        <el-form label-width="120px">
          <el-form-item label="撤销原因:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cheShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">确定</el-button>
        </div>
    </el-dialog>
        
    <el-drawer :wrapperClosable= false title="排班" :visible.sync="addShow" :direction="direction" size="50%">

      <el-form label-width="140px" :model="editSiteClassForm"   ref="editSiteClassForm" style="margin-bottom:100px">
        <el-form-item label="排班方式：" v-if="!SiteEdit" prop="dateType">
             <el-radio-group v-model="dateType" @change="changeDateType">
                <el-radio label="1">按日</el-radio>
                <el-radio label="2">按时间范围</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="日期：" prop="startTime" v-if="dateType == 1 && !SiteEdit">
          <el-date-picker 
              v-model="editSiteClassForm.startTime"
              type="date"
              size="mini"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="周期：" prop="Cycle" v-if="dateType == 2 && !SiteEdit">
            <el-checkbox-group v-model="checkedCycles" @change="handleChange">
                <el-checkbox v-for="item in CycleList" :label="item.Id" :key="item.index" name="Cycle">
                    {{item.Label}}
                </el-checkbox>
            </el-checkbox-group>
            <div class="inputSubLabel">多选周期可批量排班</div>
        </el-form-item>
        <el-form-item label="时间范围：" prop="startTime" v-if="dateType == 2 && !SiteEdit">
            <el-date-picker 
                            v-model="editSiteClassForm.startTime"
                            type="date"
                            size="mini"
                            @change="changeTime"
                            placeholder="开始日期"
                            value-format="yyyy-MM-dd">
            </el-date-picker> 
            <span v-if="!isEdit "> 至 </span>
            <el-date-picker v-if="!isEdit "
                        size="mini"
                            v-model="editSiteClassForm.endTime"
                            type="date"
                            @change="changeTime"
                            placeholder="结束日期"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
            <div  class="inputSubLabel">时间范围就是这一次排班有效的日期范围，比如从5月1日至5月31日；系统将自动在这个范围内，去检索上面“周一到周日”所勾选的“周几”进行排班</div>
        </el-form-item>

        <el-form-item :label="WZCDName+'：'" prop="Site"  v-if="!SiteEdit">
          <el-select v-model="siteName" placeholder="请选择"  @change="handlesiteList" size="small">
                <el-option
                  v-for="item in siteList"
                  :key="item.index"
                  :label="item.SiteName"
                  :value="item">
                </el-option>
              </el-select>
        </el-form-item>
    
     <el-form-item :label="WZCDName+'：'" prop="Site"  v-if="SiteEdit">
           <div class="flexc-cen-x" style="width:100%">
                <div style="margin-left:10px;font-size:16px;">
                    {{SiteInfo.SiteName}}
                </div>
            </div>
        </el-form-item>
 
      <el-form-item label="时长：" v-if="editSiteClassForm.SiteID>0">
            <div class="flexc-cen-x" style="width:100%">
                <div style="margin-left:10px;font-size:16px;">
                   {{Timelength}}分钟/{{TimelengthAmount}}元
                </div>
            </div>
        </el-form-item>
        
        <el-form-item label="支持会员卡：" v-if="editSiteClassForm.SiteID>0">
            <div class="flexc-cen-x" style="width:100%">
                <div style="margin-left:10px;font-size:16px;">
                    {{allCardName}}
                </div>
            </div>
        </el-form-item>
      
             
        <el-form-item label="预约时间表：" v-if="editSiteClassForm.SiteID>0"  prop="RowClassType">
            <el-button type="default" size="mini" @click="RowClassTimeClick">添加时间表</el-button>
            <div class="g-items-wrap f-mt-10 " >
                <div class="itemWrap___33SF3"  v-for="item in listRowClassTime" :key="item.index" :id="item.ID" >
                    <span v-if="item.state !='3'" >{{item.startTime}} ~ {{item.endTime}}</span>
                </div>
            </div>
        </el-form-item>

        <el-form-item label="开启线上支付：" prop="IsPay" v-if="IsPay == 1">
             <el-radio-group v-model="editSiteClassForm.isPay">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
 
       
        
      </el-form>
        <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          
          <el-button style="margin-left:20px"
          size="small"
          type="danger"
           v-if="SiteEdit"
           @click="todelLook()"
          >删除 </el-button>
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editSiteClassForm')"
            >保存</el-button>
           
        </div>
    </el-drawer>
           <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="添加时间表"
            direction="rtl"
            size="50%"
            :visible.sync="RowClassTimeShow"
 
            >          
            <div class="drawerForm" style="width:95%;margin-left:2.5%">
                <div>
                    <el-alert
                        title="安排一个或多个时间段，让学员选择预约"
                        type="warning" :closable="false"
                        show-icon>
                    </el-alert>
                    <div class=" f-mt-10" >
                      <el-table
                          :data="listRowClassTime"
                          style="width: 100%">
                          <el-table-column
                            align="center"
                            prop="date"
                            label="时间"
                           >
                           <template slot-scope="scope">
                             <span>{{scope.row.startTime}} ~ {{scope.row.endTime}}</span>
              
                          </template>
                          </el-table-column>
                          <el-table-column v-if="isck==1"
                            align="center"
                            prop="xhnumber"
                            label="消耗次数"
                            >
                          
                          </el-table-column>
                          <el-table-column v-if="iscx==1"
                            align="center"
                            prop="Amount"
                            label="消耗金额">
                          </el-table-column>
                          <el-table-column
                            fixed="right"
                            label="操作"
                            width="120">
                            <template slot-scope="scope">
                                 <el-button  @click.native.prevent="deleteRow(scope.$index, listRowClassTime,scope.row)" type="text" size="small">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      
                    </div>
                      <div style="margin-top:20px;margin-bottom:100px">
                        <span style="font-size:12px;margin-left:10px">开始时间：</span>

                   <el-select v-model="sTime" placeholder="请选择" size="small" clearable @change="selectEndTimes">
                    <el-option
                      v-for="item in StimeList"
                      :key="item.ID"
                      :label="item.startTime"
                      :value="item.startTime"
                       >
                    </el-option>
                  </el-select>
                  <div style="margin-top:10px"   >
                      <span style="font-size:12px;margin-left:10px">结束时间：</span>
                    <el-select v-model="eTime" placeholder="请选择" size="small" clearable>
                    <el-option
                      v-for="item in EtimeList"
                      :key="item.ID"
                      :label="item.startTime"
                      :value="item.startTime">
                    </el-option>
                  </el-select>
                   </div>
                       <div style="margin-top:10px" v-if="isck==1"  >
                        <span style="font-size:12px;margin-left:10px;">消耗次数：</span> <el-input v-model="xhnumber" style="width:120px"   size="small" ></el-input>
                      </div>
                       
                      <div style="margin-top:10px" v-if="iscx==1">
                         <span style="font-size:12px;margin-left:10px;">消耗金额：</span> <el-input v-model="Amount" style="width:120px" size="small" ></el-input>
                      </div>
                          <el-button style="margin-top:15px" icon="el-icon-plus" size="small" type="primary" @click="addRowClassTimeClick1" >添加</el-button>
                      </div>
                </div>
            </div>
    </el-drawer> 

        <el-dialog title="详情" :visible.sync="PreInfoVisible" width="40%">

    <el-form label-width="120px" >
         <el-form-item label="姓名:"  >
              {{PreInfo.Name}}
        </el-form-item>
         <el-form-item label="手机号:"  >
              {{PreInfo.Phone}}
        </el-form-item>
        <el-form-item label="预约时间:"  >
              {{PreInfo.sTime +'~' + PreInfo.eTime}}
        </el-form-item>
        <el-form-item label="会员卡:"  >
              {{PreInfo.vipName}}
        </el-form-item>
      <el-form-item label="预约人数:"  >
              {{PreInfo.PreAboutCount}}
        </el-form-item>
        <el-form-item label="备注:"  >
              {{PreInfo.Note}}
        </el-form-item>
      <el-form-item label="状态:"  >
                       <span class="Info" v-if="PreInfo.state == 0">
                        学员取消
                      </span>
                      <span class="coBlue" v-if="PreInfo.state == 1">
                        已预约
                      </span>
                      <span class="Success" v-if="PreInfo.state == 2">
                        已{{typeName}}
                      </span>
                      <span class="Danger" v-if="PreInfo.state == 3">
                      未到
                      </span>
                      <span class="Info" v-if="PreInfo.state == 4">
                        机构取消
                      </span>
                      <span class="Warning" v-if="PreInfo.state == 5">
                      请假
                      </span>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
       <el-button size="mini" type="success" v-if="(PreInfo.state == 2||PreInfo.state == 3 || PreInfo.state == 5 ) && q5 == true"   @click="chexiao(PreInfo)" >撤销</el-button>
                <el-button size="mini" type="primary"  v-if="PreInfo.state == 1 && q2 == true" @click="hexiao(PreInfo)" >{{typeName}}</el-button>
                <el-button size="mini" type="warning" v-if="PreInfo.state == 1 && q3 == true" @click.native.prevent="todel(PreInfo)" >取消预约</el-button>
                <!-- <el-button size="mini" type="warning" v-if="PreInfo.state != 1 && q3 == true" disabled @click.native.prevent="todel(PreInfo)" >取消预约</el-button> -->
                <el-button size="mini" type="info" v-if="PreInfo.state == 1 && q4 == true" @click.native.prevent="todel1(PreInfo)" >未到</el-button>
                <!-- <el-button size="mini" type="info" v-if="PreInfo.state != 1 && q4 == true" disabled @click.native.prevent="todel1(PreInfo)" >未到</el-button> -->
        <el-button size="small"  @click="PreInfoVisible = false">关闭</el-button>
     </div>
    </el-dialog>
  </div>
</template>

<script>

import CropperImage from "../../components/CropperImage";
import  Editor from '../../components/editor'

import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      title1:'',
      DianList:[],
      yuyueShow:false,
      yuyueShowSJ:false,
      RowClassTimeShow:false,
      oldData:null, // 开始排序时按住的旧数据
      newData:null,// 拖拽过程的数据
      preShow:false,
      cropperModel: false,
      hexiaoShow:false,
      addShow:false,
      cardType:'',
      isCode:'',
      code:'',
      MembersID:'',
      MembersID1:'',
      number:'',
      money:'',
      Amount:'0',
      xhnumber:'1',
      personList:[],
      terName:'',
      mainList:[],
      listRowClassTime:[],
      listRowClassTimeCopy:[],
      StaffID:'',
      PayAmountqt:0,
      vipID:'',
      cropperName: "",
      colorShow:false,
      isEdit:false,
      isedit:0,
      imgName: "",
      sTime: "",
      eTime: "",
      SleletyyTime: "",
      PayAmount:'',
      Timelength:'60',
      TimelengthAmount:'0',
      imgVisible: false,
      PreInfoVisible: false,
      PreInfo:{},
      vipList:[],
      MembersvipList:[],
      iswkyy:'0',
      StimeList:[],
      EtimeList:[],
      siteList:[],
      vipShow:false,
      date:new Date(),
      formValidate: {
        mainImage: "",
      },
      cardList:[],
      PreAboutCount:1,
      isPreAboutInfo:1,
      showList:[],
      timer:'',
      allCardName:'',
      value:'1',
      isbxsc:0,
      isMembers:1,
      selectName:'',
       selectMemberName:'',
      selectSiteID:'',
      selectSiteTypeID:'',
      vipName:'',
      vipNames:'',
      isChooseVip:1,
      active:0,
      Note:'',
      hour:'',
      minute:'',
      dateType:'1',
      SiteClassID:'0',
      timeList:[],
      vipShow:false,
      colorList:[
          '#FEFF99',
          '#FBB0A1',
          '#BCFD84',
          '#95E2F5',
          '#928FD9',
          '#47D95E',
          '#E5D0C4',
          '#9c4b4b',
          '#db6a51',
          '#f5c856',
          '#75c090',
          '#ed707a',
          '#b0649a',
          '#d19fc9',
          '#8b9599',
          '#9c8088',
          '#a6c399',
          '#5b6fc1',
          '#9583b0',
          '#b0a763',
          '#da8e6d',
          '#b07187',
      ],
            coursetime:[{
          value: '00',
          label: '00'
        }, {
          value: '01',
          label: '01'
        }, {
          value: '02',
          label: '02'
        }, {
          value: '03',
          label: '03'
        }, {
          value: '04',
          label: '04'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '06',
          label: '06'
        }, {
          value: '07',
          label: '07'
        }, {
          value: '08',
          label: '08'
        }, {
          value: '09',
          label: '09'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }],
      coursetminu:[{
          value: '00',
          label: '00'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '25',
          label: '25'
        }, {
          value: '30',
          label: '30'
        }, {
          value: '35',
          label: '35'
        }, {
          value: '40',
          label: '40'
        }, {
          value: '45',
          label: '45'
        }, {
          value: '50',
          label: '50'
        }, {
          value: '55',
          label: '55'
        }],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      IsPay:localStorage.getItem("IsPay"),
      hyIsPay:localStorage.getItem("hyIsPay"),
      spIsPay:localStorage.getItem("spIsPay"),
      gkIsPay:localStorage.getItem("gkIsPay"),
      hdIsPay:localStorage.getItem("hdIsPay"),
      xmIsPay:localStorage.getItem("xmIsPay"),
      typeName:'',
       Name:'',
      Phone:'',
      name:'全部',
      id:'',
      active:'',
      img1:'',
      img2:'',
      img3:'',
      activeName: 'first',
      SelectStoresID:localStorage.getItem("StoresID"),
      direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      timer:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      sortSure:false,
      SiteTypeName:'',
      siteName:'',
      ListPreAboutForms:[],
      options:[],
      yysc:1,
      iszjyy:"",
      weiShow:false,
      WZCDName: localStorage.getItem('WZCDName'), 
      lay:[
        {
          value:'1',
          label:'必填'
        },
            {
          value:'0',
          label:'选填'
        }
      ],
      
      Pwd:'',
      typeList:[],
      cheShow:false,
      Limits:[],
       coursetime:[{
          value: '00',
          label: '00'
        }, {
          value: '01',
          label: '01'
        }, {
          value: '02',
          label: '02'
        }, {
          value: '03',
          label: '03'
        }, {
          value: '04',
          label: '04'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '06',
          label: '06'
        }, {
          value: '07',
          label: '07'
        }, {
          value: '08',
          label: '08'
        }, {
          value: '09',
          label: '09'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }],coursetminu:[{
          value: '00',
          label: '00'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '25',
          label: '25'
        }, {
          value: '30',
          label: '30'
        }, {
          value: '35',
          label: '35'
        }, {
          value: '40',
          label: '40'
        }, {
          value: '45',
          label: '45'
        }, {
          value: '50',
          label: '50'
        }, {
          value: '55',
          label: '55'
        }],
      checkedCycles:[],
      CycleList:[
                    {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
                ],
      startTimenew:"08:00",
      SiteID:0,
      SiteInfo:{},
      SiteClassInfo:{},
      isck:0,
      iscx:0,
      editSiteClassForm: {
        SiteID:'',
        Cycle:'',
        PKtime:'',
        endTime:'',
        startTime:'',
        isPay:'0',
      },
      editForm: {
        color:'#b0649a',
        Timelength:60,
        isjp:0,
        ishot:0,
        isPreAboutInfo:0,
        PayAmount:0,
        SiteName:'',
        isshelves:1,
        HeadUrl:'',
        Amount:0,
        SiteTypeID:'',
        CardIDs:'',
        isPay:0,
        TimelengthAmount:0,
        token: localStorage.getItem('token'),
        ListPreAboutForms:[],
      },
      // rules表单验证
      isCard:localStorage.getItem('isCard'),
      rules: {
        SiteName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        SiteTypeID:[{ required: true, message: '请选择类别', trigger:  'blur' }],
        HeadUrl: [{ required: true, message: '请选择分辨图', trigger: 'blur' }],
      
      },
  name1:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      subList:[],
      cardList:[],
      ListSiteClassTime:[],
      subName:'',
      MembersSubID:'',  
      RowClassTimeID:'', 
      timeShow:false,
      timeList:[],
      yyList:[],
      meeting:[],
           pageparm1: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      personShow:false,
      SiteEdit:false,
      days:'',
      times:'',
      wdtype:1,
       info:[],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Editor,
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
     var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
         
        // this.data.[0] = 
      this.date = year + '-' + month + '-' + day;
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZCDName'), 
    this.WZPBName = localStorage.getItem('WZPBName')

    this.iszjyy = localStorage.getItem('iszjyy')
    this.name1 = '预约资料'
      if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 162){
              this.q1 = true
            }
            if(items == 163){
              this.q2 = true
            }
            if(items == 164){
              this.q3 = true
            }
            if(items == 165){
              this.q4 = true
            }
            if(items == 166){
              this.q5 = true
            }
            
          
    })



 
     this.getType()
     this.getList()
     this.getDianList()
     this.getList1()
     this.getList2()

  
   },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        sureChe(){
      if(this.Note == ''){
         this.$message({ type: "error", message: "请选择原因" ,duration:1000});
         return;
      }
      this.SiteID =this.showList.ID;
      var that = this
          if(this.mainList.isZF == 1){
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutPayCD.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000
                  });
                  that.cheShow = false
                 that.getSiteYYInfo(that.showList)
                 
                }
            })
          
          }  else {
           if(this.isCard == 1){
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginName:localStorage.getItem("Name"),
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
              }
              this.ajax('RevocationPreAboutCD.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {

                    that.$message({
                      type: "success",
                      message: "撤销成功",duration:2000
                    });
                   that.cheShow = false
                   that.PreInfoVisible= false

                  that.getSiteYYInfo(that.showList)
                    //  that.provinceList = res.data
                  }
              })
           } else {
               var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutNoCradCD.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000
                  });
                  that.cheShow = false
                   that.getSiteYYInfo(that.showList)
                  //  that.provinceList = res.data
                }
            })
          
           }
        }
    }, getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListSiteType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },changeSiteTypeID(){
      this.getList2();
    },
    getList2(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:1000,
          SiteTypeID:this.selectSiteTypeID
       }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.ListSite = res.data
                 loading.close();
          } 

      })
  
    },
    handlesiteList(itmes1){
      this.editSiteClassForm.SiteID = itmes1.ID;
      this.siteName = itmes1.SiteName;
      this.allCardName = itmes1.allCardName;
      this.isck= itmes1.isck
      this.iscx= itmes1.iscx
      this.Timelength= itmes1.Timelength;
      this.TimelengthAmount= itmes1.TimelengthAmount;
    },
    handleSiteClass(){
      this.SiteEdit =false;
      this.getSiteList()
    },
    todelLook(){
        this.$confirm("确定要删除排的班吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteClassID:this.SiteClassID,
        
        }
        var that = this
        this.ajax('delSiteClass.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000
              });
               that.getList()

               that.closeDialog()

             }

        })
        })
        .catch(() => {
            ;
        });
    },
    toLook(itmes){
      this.SiteID = itmes.ID;
      this.SiteClassID = itmes.SiteClassID;

      this.SiteEdit =true;
      this.getSiteClassInfo();
    },
    getSiteClassInfo(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          PKtime:this.date,
          SiteID:this.SiteID,

      }
  
        var that = this
      this.ajax('getSiteClassInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.allCardName = res.allCardName
                that.SiteInfo= res.Siteinfo
                that.Timelength= res.Siteinfo.Timelength;
                that.TimelengthAmount= res.Siteinfo.TimelengthAmount;
                that.editSiteClassForm= res.info
                that.isck= res.isck
                that.iscx= res.iscx
                that.listRowClassTime= res.listtime
 
                that.Copytimes()
                that.addShow =true;
          } 

      })
    }, 
    Copytimes(){
  let arr =[]
   this.listRowClassTime.forEach(items => {
              arr.push(items);
           });
           this.listRowClassTimeCopy =arr
},
  changeDateType(){
    this.editSiteClassForm.startTime = ''
    this.editSiteClassForm.endTime = ''
    this.checkedCycles = []
  },submitForm(editData){
    if(this.SiteEdit){
       var data ={} 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                data.SiteClassID  = this.editSiteClassForm.ID
                data.SiteID  = this.editSiteClassForm.SiteID
                data.isPay  = this.editSiteClassForm.isPay

                var that = this
       let list = JSON.stringify(this.listRowClassTimeCopy)
                          data.ListSiteClassTime = list
                          this.ajax('editSiteClass.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.addShow = false
                            that.getList()
                        }

                    })
    }else{
if(this.dateType==1){
      if(this.editSiteClassForm.startTime==''){
         this.$message({ type: "error", message: "请选择日期" ,duration:1000});
          return;
      }
    }else{
      if(this.editSiteClassForm.startTime==''){
         this.$message({ type: "error", message: "请选择开始日期" ,duration:1000});
          return;
      }
      if(this.editSiteClassForm.endTime==''){
         this.$message({ type: "error", message: "请选择结束时间" ,duration:1000});
          return;
      }
    
    }
     if(this.editSiteClassForm.SiteID==0){
         this.$message({ type: "error", message: "请选择场地" ,duration:1000});
          return;
      }
      if(this.listRowClassTime.length==0){
         this.$message({ type: "error", message: "请选择预约时间" ,duration:1000});
          return;
      }
       var data =this.editSiteClassForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
                if(this.dateType == 1){
                   let list = JSON.stringify(this.listRowClassTime)
                          data.ListSiteClassTime = list
                          this.ajax('addSiteClassToday.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.addShow = false
                            that.getList()
                        }

                    })
                }else{
                    let list = JSON.stringify(this.listRowClassTime)
                          data.ListSiteClassTime = list
                          this.ajax('addSiteClass.aspx',JSON.stringify(data),"POST",function(res){
                        if (res.orsuccess == "1") {
                            that.$message({
                                type: "success",
                                message: "新建成功",duration:2000,
                            });
                            that.addShow = false
                            that.getList()
                        }

                    })
                }
    

    }
    
  },changeTime(){
    // this.editForm.startTime
    if(this.editSiteClassForm.startTime && this.editSiteClassForm.endTime){
      if(this.editSiteClassForm.startTime>this.editSiteClassForm.endTime){
         this.$message({    
                message: "开始日期不得小于结束日期",
          });

      } else {
          var day1 = new Date(this.editSiteClassForm.startTime);
          var day2 = new Date(this.editSiteClassForm.endTime);
          var day = (day2 - day1) / (1000 * 60 * 60 * 24) + 1
          if(day>31){
            this.$message({    
                message: "最多只能排31天",
          });
          }

      }
      
    }
    console.log(this.editSiteClassForm.startTime)
    console.log( this.editSiteClassForm.endTime)
  },addRowClassTimeClick1(){
    var startTime = this.sTime;
        var endTime = this.eTime;
        var Amount = this.Amount
        var xhnumber = this.xhnumber 
    this.listRowClassTime.push({
                                ID:"0",
                                startTime:startTime,
                                endTime:endTime,
                                Amount:Amount,
                                xhnumber:xhnumber,
                                state:"1",
                            })
                            if(this.SiteEdit){
                              this.listRowClassTimeCopy.push({
                                ID:"0",
                                startTime:startTime,
                                endTime:endTime,
                                Amount:Amount,
                                xhnumber:xhnumber,
                                state:"1",
                            })
                              
                            }
  },
      deleteRow(index, rows,row) {

        
        if(this.SiteEdit){
          this.listRowClassTimeCopy.forEach(items => {
               if(items.ID >0 && items.ID == row.ID){
                  items.state="3";
               }
           });
        }
         
        rows.splice(index, 1);
      },
    handleChange(val,item){
        this.editSiteClassForm.Cycle = val.join();
     },
    getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:800,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
                
                 that.addShow =true;
          } 

      })
    },RowClassTimeClick(){
    //  alert(this.editSiteClassForm.SiteID)
    this.sTime='';
    this.eTime='';
    this.Amount ='0';
    this.xhnumber ='0';
      this.SiteID=this.editSiteClassForm.SiteID;
      this.getCDTims()
     
      this.RowClassTimeShow = true;
    },
  
    chexiao(row){
        this.mainList = row
        this.cheShow = true
        this.Note = ''
    },
   sure(){
        if(this.vipID == '' && this.isChooseVip == 1){
             this.$message({ type: "error", message: "请选择会员卡" ,duration:1000});
                          return;  
        }
        if(this.isChooseVip == 2){
          this.vipID = 0
        }

      if(this.code == '' && this.mainList.isZF == 1){
        this.$message({ type: "error", message: "请输入码" ,duration:1000});
                          return;
      }
      var code = 0
      if(this.mainList.isZF == 1){
          code = 1
      }

 this.$confirm('是否确认'+ this.typeName, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
              var data = { 
                
                  SelectStoresID:this.SelectStoresID,        
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  PreAboutID:this.mainList.ID,
                  vipID:this.vipID,
                  loginID:localStorage.getItem("LoginID"),
                  Note:this.Note,
                  sourceName:localStorage.getItem("Name"),
                  isCode:code,
                  PayAmountqt:this.PayAmountqt,
                  VerificationCode:this.code,
                  ConsumptionOfClass:this.number,
                  singlePrice:this.money,
                  PreAboutCount:this.mainList.PreAboutCount,
                  StaffID:this.StaffID
                
                }
        var that = this
        this.ajax('editPreAboutCDState.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.hexiaoShow = false
              that.getSiteYYInfo(that.showList)
              that.PreInfoVisible =false;
              that.getList()

              //  that.provinceList = res.data
            }

        })
                    }).catch(() => {
                            
                    });
                

      
    
    },

     choose(items){
      
          this.terName = items.Name
          this.StaffID = items.ID
          this.personShow = false

      },
     getList1(){

    //  this.tableLoading = true
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
      var that = this
      this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          
                that.personList = res.data
          } 

      })
  
  
    },
          handlePassword1(){

        this.personShow = true

    },
    hexiao(row){
      this.mainList = row
      this.hexiaoShow = true
      this.terName = ''
      this.StaffID = ''
      this.code = ''
      this.Note = ''
      this.iscode = 1
      this.money = this.mainList.xhAmount
      this.number = this.mainList.xhnumber
      this.PayAmountqt  =  row.PayAmountqtsy

    //  this.PayAmountqt  =  Number(this.mainList.YYSource) *Number(this.showList.TimelengthAmount)  - Number(this.mainList.PayAmount)
      this.vipID = row.vipID
      this.cardType = row.cardType
      this.vipName = row.vipName
      this.iswkyy = this.mainList.iswkyy
      this.MembersID1= row.MembersID
      this.SiteID = row.SiteID

      if(this.isCard == 1 ){
           this.getContainsMemberVipCD()
        } 
    },
getListMembersvip(){
         
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.mainList.MembersID
      }

      var that = this
      this.ajax('getListMembersvip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.cardList =res.data
     
          } 

      })
     this.vipID =''
    },tochoosevip(row){
     // alert(row.vipID)
   this.vipID = row.vipID;
  this.vipNames = row.CardName;
     this.cardType = row.CardType

      //  this.MembersvipList.forEach(items=>{
      //           if(this.vipID == items.vipID){

      //              this.cardType = items.CardType
      //                                      alert(this.cardType)

                      
      //           }
      //         })
            
       
    },handleSleletyyTime(){
      this.sTime='';
       this.eTime='';
       this.getCDTims();

    },
     subm(){
      var infoList = []
      if(this.showList.isPreAboutInfo == 1){
       for(var i = 0;i<this.ListPreAboutForms.length;i++){
              if(this.ListPreAboutForms[i].fType != 2){
                var t = {
                      FormsID:this.ListPreAboutForms[i].ID,
                      FormsInfo:this.ListPreAboutForms[i].info
                }
              } else {
                  var t = {
                    FormsID:this.ListPreAboutForms[i].ID,
                    FormsInfo:this.ListPreAboutForms[i].info
                  }
                  if(this.ListPreAboutForms[i].date !='' &&this.ListPreAboutForms[i].time !='' &&this.ListPreAboutForms[i].time1 !='' ){
                        var t = {
                        FormsID:this.ListPreAboutForms[i].ID,
                        FormsInfo: this.ListPreAboutForms[i].date + ' ' + this.ListPreAboutForms[i].time +':' + this.ListPreAboutForms[i].time1 
                      }
                  } 
              
              }
          if(this.ListPreAboutForms[i].isbt == 1){
            if(t.FormsInfo == ''){
                this.$message({ type: "error", message: "请填写表单" ,duration:1000});
                return; 
            }
          } 
          infoList.push(t)
          
      }
    }
    if(this.MembersID == '' && this.isMembers == 1){
                   this.$message({ type: "error", message: "请选择会员" ,duration:1000});
                  return;
      }
    if(this.Phone =='' && this.isMembers == 0 && this.Name == ''){
                   this.$message({ type: "error", message: "请输入非会员信息" ,duration:1000});
                  return;
      }
 if(this.sTime =='' ){
     this.$message({ type: "error", message: "请输入开始时间" ,duration:1000});
                  return;
      }
if(this.eTime =='' ){
     this.$message({ type: "error", message: "请输入结束时间" ,duration:1000});
                  return;
      }
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          yyTime:this.SleletyyTime,
          sTime:this.sTime,
          eTime: this.eTime,
          yysc:this.yysc,
          isbxsc:this.isbxsc,
          MembersID:this.MembersID,
          MembersSubID:this.MembersSubID,
          loginID: localStorage.getItem("LoginID"),
          PreAboutCount:this.PreAboutCount,
          ListPreAboutInfo:JSON.stringify(infoList),
          Note:this.Note,
          isZF:2,
          PayAmount:this.PayAmount,
          Phone:this.Phone,
          Name:this.Name,
          isMembers:this.isMembers,
          SiteID:this.SiteID,
          vipID:this.vipID,
        }
        var that = this
        this.ajax('addPreAboutCD.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.$message({
                    type: "success",
                    message: "预约成功",duration:2000,
                  });
                  that.getList()
                  that.yuyueShow = false
                  that.getSiteYYInfo(that.showList)
              //  that.provinceList = res.data
            } else {
                that.$message({
                    type: "info",
                    message:res.Msg,duration:2000,
                });
      
              that.timeList = res.data
              that.timeShow = true
            }

        })
    

      
    }, subm1(){
      var infoList = []
      if(this.showList.isPreAboutInfo == 1){
       for(var i = 0;i<this.ListPreAboutForms.length;i++){
              if(this.ListPreAboutForms[i].fType != 2){
                var t = {
                      FormsID:this.ListPreAboutForms[i].ID,
                      FormsInfo:this.ListPreAboutForms[i].info
                }
              } else {
                  var t = {
                    FormsID:this.ListPreAboutForms[i].ID,
                    FormsInfo:this.ListPreAboutForms[i].info
                  }
                  if(this.ListPreAboutForms[i].date !='' &&this.ListPreAboutForms[i].time !='' &&this.ListPreAboutForms[i].time1 !='' ){
                        var t = {
                        FormsID:this.ListPreAboutForms[i].ID,
                        FormsInfo: this.ListPreAboutForms[i].date + ' ' + this.ListPreAboutForms[i].time +':' + this.ListPreAboutForms[i].time1 
                      }
                  } 
              
              }
          if(this.ListPreAboutForms[i].isbt == 1){
            if(t.FormsInfo == ''){
                this.$message({ type: "error", message: "请填写表单" ,duration:1000});
                return; 
            }
          } 
          infoList.push(t)
          
      }
    }
    if(this.MembersID == '' && this.isMembers == 1){
                   this.$message({ type: "error", message: "请选择会员" ,duration:1000});
                  return;
      }
    if(this.Phone =='' && this.isMembers == 0 && this.Name == ''){
                   this.$message({ type: "error", message: "请输入非会员信息" ,duration:1000});
                  return;
      }
 if(this.RowClassTimeID ==0  || this.RowClassTimeID ==''){
     this.$message({ type: "error", message: "请选择时间" ,duration:1000});
                  return;
      }
 
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          yyTime:this.date,
          RowClassTimeID:this.RowClassTimeID,
          yysc:this.yysc,
          isbxsc:this.isbxsc,
          MembersID:this.MembersID,
          MembersSubID:this.MembersSubID,
          loginID: localStorage.getItem("LoginID"),
          PreAboutCount:this.PreAboutCount,
          ListPreAboutInfo:JSON.stringify(infoList),
          Note:this.Note,
          isZF:2,
          PayAmount:this.PayAmount,
          Phone:this.Phone,
          Name:this.Name,
          isMembers:this.isMembers,
          SiteID:this.SiteID,
          vipID: this.vipID,
        }
        var that = this
        this.ajax('addPreAboutSJCD.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.$message({
                    type: "success",
                    message: "预约成功",duration:2000,
                  });
                  that.getList()
                  that.yuyueShowSJ = false
                  that.getSiteYYInfo(that.showList)
              //  that.provinceList = res.data
            } else {
                that.$message({
                    type: "info",
                    message:res.Msg,duration:2000,
                });
      
              that.timeList = res.data
              that.timeShow = true
            }

        })
    

      
    },forceUpdate () { 
    this.$forceUpdate() 
  },getCDTims(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteID: this.SiteID,
          yyTime:this.SleletyyTime,
        }
        var that = this
        this.ajax('getCDTimsNew.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.StimeList = res.data
          
             }

        })
  },selectEndTimes(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteID: this.SiteID,
          sTime:this.sTime,
          yyTime:this.SleletyyTime,
        }
        var that = this
        this.ajax('getCDEndTimesNew.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.EtimeList = res.data
          
             }

        })
  },getListSiteClassTime(){
     var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteClassID: this.SiteClassID,
        
        }
        var that = this
        this.ajax('getListSiteClassTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.ListSiteClassTime = res.data
          
             }

        })
  },
    getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:3,
          objID:this.SiteID,
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.ListPreAboutForms = res.data
              that.ListPreAboutForms.forEach(items => {
                  items.info = ''
                  items.date = ''
                  items.time = ''
                  items.time1 = ''
              });
              that.timer = new Date().getTime()
              that.preAbout = true
              if(that.isedit==0){
                that.yuyueShow = true
              }else{
                 that.yuyueShowSJ = true
              }
              
              //  that.provinceList = res.data
            }

        })
  
},
    handleDetail(items){        
         
        this.vipName = items.Name
        this.MembersID = items.ID
        this.MembersID1 = items.ID

        
        this.vipShow = false
        this.getSubList()
        this.getContainsMemberVipCD();
    },
     getContainsMemberVipCD(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.MembersID1,
          SiteID:this.SiteID,
          yyTime:this.date,
           }
          var that = this
       this.ajax('getContainsMemberVipCD.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.MembersvipList =res.data  
                that.iswkyy =res.iswkyy  

             
            }
      })
      // this.ziShow = true
    },
     getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.MembersID,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList =res.data  
               that.subName = ''
               that.MembersSubID = ''    
            }
      })
      // this.ziShow = true
    },
    toAdd1(){
            this.PreAboutCount = 1;
            this.isMembers = 1;
            this.Phone = '';
            this.Name = '';
            this.minute = '';
            this.hour = '';
            this.RowClassTimeID='';
            this.isbxsc = 0;
            this.yysc = 1;
            this.vipName = '';
            this.PayAmount = this.showList.PayAmount;
            this.MembersID = '';
            this.vipID='';
            this.SiteClassID =this.yyList.SiteClassID;
            this.isedit =this.yyList.isedit;
            this.MembersvipList =[];

            this.getListSiteClassTime();
            this.getPreAboutInfo()
    },
      toAdd(){
            this.PreAboutCount = 1;
            this.isMembers = 1;
            this.Phone = '';
            this.Name = '';
            this.minute = '';
            this.hour = '';
            this.isbxsc = 0;
            this.yysc = 1;
            this.vipID='';
            this.vipName = '';
            this.sTime = '';
            this.eTime = '';
            this.SleletyyTime = this.date;
            this.PayAmount = this.showList.PayAmount;
            this.MembersID = '';
            this.yuyueShow = true;
            this.SiteID = this.showList.ID;
            this.isedit =this.yyList.isedit;
            this.MembersvipList =[];

            this.getCDTims();
            this.getPreAboutInfo()
      },toSowPreInfo(row){
        this.PreInfo = row;
        this.PreInfoVisible =true;
      },toAddnew1(row){
        
            this.PreAboutCount = 1;
            this.isMembers = 1;
            this.Phone = '';
            this.Name = '';
            this.minute = '';
            this.hour = '';
            this.RowClassTimeID='';
            this.isbxsc = 0;
            this.yysc = 1;
            this.vipName = '';
            this.PayAmount = row.PayAmount;
            this.MembersID = '';
            this.SiteID = row.ID;
            this.SiteClassID =row.SiteClassID;
            this.isedit =row.isedit;
            this.vipID='';
            this.MembersvipList =[];

            this.getListSiteClassTime();
            this.getPreAboutInfo()
    },
      toAddnew(row){
            this.PreAboutCount = 1;
            this.isMembers = 1;
            this.Phone = '';
            this.Name = '';
            this.minute = '';
            this.hour = '';
            this.isbxsc = 0;
            this.yysc = 1;
            this.vipName = '';
            this.PayAmount = row.PayAmount;
            this.MembersID = '';
            this.sTime = '';
            this.eTime = '';
            this.SleletyyTime = this.date;
            this.yuyueShow = true;
            this.SiteID = row.ID;
            this.isedit =row.isedit;
            this.vipID='';
            this.MembersvipList =[];

            this.getCDTims();
            this.getPreAboutInfo()
      },
    callFather1(parm) {
      this.formInline1.page = parm.currentPage
      this.formInline1.limit = parm.pageSize
      this.getvipList()
    },
    searchhui(){

      this.formInline1 =  {
          page: 1,
          limit:10,
      },
      this.getvipList()

    },
        toVipShow(){
      this.formInline1 =  {
          page: 1,
          limit:10,
      },
      this.selectName=''
      this.getvipList()
      this.vipShow =  true
    },
       getvipList(){
      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline1.page,
          psize:this.formInline1.limit,
          selectName:this.selectName,
      }
    
      
        var that = this
      this.ajax('getListMembersYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              
                that.vipList = res.data
               that.pageparm1.total = res.allcount
          } 

      })
  
},
    toMain(row){
       this.$router.push({ 

          path: `/site/siteMain/${row.ID}`,

      })
    },
      handleClick(){
          this.getList()
      },
     toSetting(){
       this.vipShow = true

    },
    toCard(){
          this.$router.push({ path: '/card/card'})
    },
 
   
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
     this.getList()
     },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},
    save(){
      var list = Array.from(this.ListPreAboutForms)
      var  cd = false
      list.forEach(items => {
        if(items.Title == ''){
            cd = true
        }
      });
      if(cd == true){
          this.$message({
              duration:2000,
              message:'请输入标题'
          });
      } else {
          this.preShow = false
          this.editForm.ListPreAboutForms =  Array.from(this.ListPreAboutForms)
      
          for(var i = 0 ;i<this.editForm.ListPreAboutForms.length;i ++){
              this.editForm.ListPreAboutForms[i].sort = i       
          }
      }
      
     
     
    },
     dragstart(value) {
            this.oldData = value
        },

        // 记录移动过程中信息
        dragenter(value, e) {
            this.newData = value
            e.preventDefault()
        },

        // 拖拽最终操作
        dragend(value, e) {
            if (this.oldData !== this.newData) {
                let oldIndex = this.ListPreAboutForms.indexOf(this.oldData)
                let newIndex = this.ListPreAboutForms.indexOf(this.newData)
                let newItems = [...this.ListPreAboutForms]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData)
                this.ListPreAboutForms = [...newItems]
            }
        },


        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
        dragover(e) {
            e.preventDefault()
        },

       todel(items){

            this.$confirm("确定要取消预约吗?", "提示", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                      .then(() => {
                      var data = { 
                        SelectStoresID:this.SelectStoresID,
                        StoresID:localStorage.getItem("StoresID"),
                        token: localStorage.getItem("token"),
                        PreAboutID:items.ID,
                        loginID:localStorage.getItem("LoginID"),
                        Note:'',
                
                      }
                      var that = this
                      this.ajax('editPreAboutStateCDQX.aspx',JSON.stringify(data),"POST",function(res){

                        if (res.orsuccess == "1") {
                            that.$message({
                              type: "success",
                              message: res.Msg,duration:2000,
                            });
                            that.getSiteYYInfo(that.showList)
                            that.PreInfoVisible =false;
                            that.getList()

                         //   that.getPreAboutInfo(that.showList)
                            //  that.provinceList = res.data
                          }

                      })
                      })
                      .catch(() => {

                      });
                


  
      },
      weidao(){
        this.$confirm("确定要做此操作吗?", "提示", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                      .then(() => {
                      var data = { 

                        SelectStoresID:this.SelectStoresID,
                        StoresID:localStorage.getItem("StoresID"),
                        token: localStorage.getItem("token"),
                        PreAboutID:this.mainList.ID,
                        loginID:localStorage.getItem("LoginID"),
                        Note:this.Note,
                        state:3,

                      }
                      var that = this
                      this.ajax('editPreAboutStateCDQT.aspx',JSON.stringify(data),"POST",function(res){

                        if (res.orsuccess == "1") {
                            that.$message({
                              type: "success",
                              message: "操作成功",duration:2000,
                            });
                          that.weiShow  = false
                             that.getSiteYYInfo(that.showList)

                        
                            that.PreInfoVisible =false;
                            that.getList()

                            //  that.provinceList = res.data
                          }

                      })
                      })
                      .catch(() => {

                      });
                


      },
      todel1(items){
        this.wdtype =1;
        this.mainList = items
        this.weiShow = true
        this.Note = ''
  
    },todel2(items){
        this.wdtype =2;
        this.mainList = items
        this.weiShow = true
        this.Note = ''
  
    },
    toadd(type){
      
        var list = {
          length:this.ListPreAboutForms.length,
          Title:'',
          fType:type,
          objID:this.editForm.ID,
          isbt:'1',
          state:1,
          objType:'3',
          isedit:0,
         
        }
     
      this.ListPreAboutForms.push(list)      
 
    },
    hover(items){
      items.show = true
      this.timer =  new Date().getTime()
      console.log(items.show)
      // console.log('1111')
    },
    UpRoll(items){
      items.show = false
      this.timer =  new Date().getTime()
 
        console.log(items.show)    
    },
    openPreAbout(){
      if(this.title == '修改'){
            for(var i= 0;i<this.editForm.ListPreAboutForms.length;i++ ){
                this.editForm.ListPreAboutForms[i].length = i
                this.editForm.ListPreAboutForms[i].state = 0
            }
      }
      this.ListPreAboutForms = this.editForm.ListPreAboutForms
      this.preShow = true
    },
    toTop(row){
      var data = { SelectStoresID:this.SelectStoresID,        

          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
          SelectStoresID:this.SelectStoresID
        }
        var that = this
        this.ajax('editProjectDesc.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
           
              that.getList()
             
            }

        })
 
    },
    toDown(row){
      var data = { SelectStoresID:this.SelectStoresID,        
         
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
         
        }
        var that = this
        this.ajax('editProjectAes.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getList()
             
            }

        })
    },
      toSort(){
          this.sortSure = true
    },
     
    toChooseColor(item){
      this.editForm.color = item
      this.colorShow =false
    },
    toColor(){
      console.log(this.colorShow)
      this.colorShow = true
    },
    toAll(){
      this.active = ''
      this.name = '全部'
      this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    toChoose(item){
        this.active = item.ID
        console.log(item.ID)
        this.name = item.SiteTypeName
        this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
        this.getList()
    },
    handlePassword(row){
        
      this.passShow = true

    },
delForm(){
this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:this.editForm.ID,
        
        }
        var that = this
        this.ajax('delProject.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.closeDialog()
               that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
},
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
        getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListSiteType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    
    getListSiteYY(){

    //  this.tableLoading = true
        var data = { 
          SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:this.formInline.page,
            psize:800,
            SiteTypeID:this.active,
            yyTime:this.date
            // StaffTypeID:this.active
        }
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        
        var that = this
        this.ajax('getListSiteYY.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  that.tableLoading = false
                  that.tableData = res.data
                  //xiaolong
          
                   loading.close();
            } 

        })


    },
    getList(){
var data = { 
          SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SiteTypeID:this.selectSiteTypeID,
            yyTime:this.date,
            SiteID:this.selectSiteID,
            SelectName:this.selectMemberName
            
        }
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        
        var that = this
        this.ajax('getListSiteYYTime.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  that.tableLoading = false
                  that.times = res.listTime
                  that.tableData1 = res.data
                  that.meeting = res.listallPreInfo

           
                   //xiaolong
          
                that.tolisttest()
                  loading.close();
            } 

        })
    },
    tolisttest(){
//  this.times = ['7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00']
//  let meeting = [
//   // 安排的数组，开始时间和持续时间，标题
//   [{
//     subject: '秘书处',
//     start: 4,
//     time: 3,
//    }],
//   [
//     {
//       subject: "团校",
//       start: 28,
//       time: 4
//     }
//   ],
//   [
//     {
//       subject: "数学",
//       start: 24,
//       time: 4,
//     },
//     {
//       subject: "组织部",
//       start: 28,
//       time: 4,
//     }
//   ],
//   [
//     {
//       subject: '信息中心',
//       start: 19,
//       time: 4,
  
//     },
//     {
//       subject: '实践部',
//       start: 28,
//       time: 4,
//      }
//   ],
//   [
//     {
//       subject: '文艺部',
//       start: 11,
//       time: 4,
//     }
//   ],
//   [
//     {
//       subject: '能动',
//       start: 15,
//       time: 4,
//     },
//     {
//       subject: '志工部',
//       start: 28,
//       time: 4,
//     },
//   ],
//   [
//     {
//       subject: '辩论队',
//       start: 5,
//       time: 9,
  
//     },
//   ],[
    
//   ],[
     
//   ],[
  
//   ],[
     
//   ],[
    
//   ],[
     
//   ],[
    
//   ],[
    
//   ],[
    
//   ],[
  
//   ] ,[
    
//   ]
// ]

 let counts = this.tableData1.length;
  let tcounts = this.times.length;
  let meetings=this.meeting
 let info = []
      // for (let i of meetings) {
      //   for (let j of i)
      //     console.log("meetings",j)
      // }

      for (let i = 0; i < tcounts; i++) {
        info[i] = []
        for (let j = 0; j < counts; j++) {
          // 1 表示空白
          info[i].push(1)
        }
      }

      for (let i = 0; i < counts; i++) {
        // m 表示第i天所有活动的集合
        // cnt 表示第i天活动数目
        let m = meetings[i]
        // console.log("meetings",m)

         for (let k of m) {
          //   console.log("k",k)

          info[k.start][i] = k

            // console.log("k.start",k.start)
            // console.log("i",i)

            for (let p = 1; p < k.time; p++)
          {
            //  console.log("k.start+ p",k.start+ p)
            //   console.log("i p",i)
            info[k.start + p][i] = null
          }
           

            
        }
      }
   //   console.log(info)
      this.info = info
    },
    // 获取公司列表


    //图片上传成功后

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getList()
    },


    //显示编辑界面
    handleEdit: function(row) {
      this.editFormVisible = true
      this.getSiteYYInfo(row)
    },
    getSiteYYInfo(row){
      this.showList  = row
 var data = { 
          SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:this.formInline.page,
            psize:100,
            SiteID:row.ID,
            yyTime:this.date
            // StaffTypeID:this.active
        }
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        
        var that = this
        this.ajax('getSiteYYInfo.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  that.tableLoading = false
                  that.yyList = res.data
                  loading.close();
            } 

        })

    },
    // 编辑、增加页面保存方法




 
    // toDel(){
    //     this.$confirm('确定要删除吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //         this.delete(row)
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.sortSure = false,
      this.colorShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.preShow = false
      this.addShow =false
      this.hexiaoShow =false

      
    }
  }
}
</script>

<style scoped>
.hidden{
  height: 48vh;
  overflow: auto;
}
.mian{
  height: 300px;
  overflow: auto;
  overflow-x: hidden
}
.hen{
  width: 95%;
  border: 1px dashed #65a8ff;
  margin-left: 2.5%;
  padding-top:10px;
  padding-bottom: 10px;
}
.mainTitle{
  border-radius: 5px;
  width: 95%;
  height: 95%;
  background-color: white;
}
.left{
  background-color: #e0e0e0;
}
.jingp{
  width:50px;

  margin-left: 10px;
  font-size: 13px;
}
.kuai{
  margin-left: 10px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.bgColor{
  width:215px;
  height:30px;
  border:1px solid #808080;
  margin-top:5px;
  border-radius: 4px;
}
.main{
  position: absolute;
}
.content{
  font-size: 14px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e1 {
    position: absolute;
    top:  100px;
    right: 11px;
    padding: 0.5px 4px 0.5px 4px;
 
    font-size: 15px;
    line-height: 20px;
    color: #3709dc;

}
.offline___NHq4e2 {
    position: absolute;
    top:  100px;
    right: 51px;
    padding: 0.5px 4px 0.5px 4px;
 
    font-size: 15px;
    line-height: 20px;
    color: #3709dc;

}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 70px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #409EFF;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}
 
.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.f-mt-10 {
    margin-top: 10px;
}
.itemWrap___33SF3 {
    text-align: left;
    margin-bottom: 8px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
 }
 .g-items-wrap {
    padding: 10px 15px;
    border: 1px dashed #40a9ff;
}
 .cell {
    text-align: center;
    box-sizing: border-box;
    background: greenyellow;

  }
 
  .cell2{
    text-align: center;
    background: lightskyblue;
    box-sizing: border-box;
  }

 
  /* .mytd:hover{
     
    border: 2px solid blue;
  } */

.all .move-table,
			.fixed-l,
			.fixed-r {
				/* background-color: #D5E4E4; */
				word-break: keep-all;
				width: 100%;
			}
			.fixed-l th,
			.all .move-table th,
			.fixed-r th,
			.fixed-l td,
			.fixed-r td,
			.all .move-table td {
				width: 150px;
				text-align: center;
				border: 1px solid #E2E2E2;
				height: 40px;
				min-width: 150px;
				max-width: 150px;
			}
			
			.l {
				position: absolute;;
				z-index: 5;
				top: 0;
				left: 0;
			}
			.r {
				position: absolute;
				z-index: 5;
				top: 0;
				right: 0;
			}

      .left {
        float: left;
        width: 155x;
        height: 100%;
        background-color: rgb(255, 255, 255);
      }
      .right {
        /* background-color: orange; */
        margin-left: 160px;
        height: 100%;
      }
 
 
</style>



// WEBPACK FOOTER //
// src/views/site/siteMain.vue